import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import ProcessSection from "@/components/sections/ProcessSection";
import WhySection from "@/components/sections/WhySection";
import EditorialMarquee from "@/components/Marquee";
import CTASection from "@/components/sections/CTASection";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/data/content";

const VALUES = [
  { h: "Mechanical knowledge", p: "Deep understanding of how heating and cooling systems actually behave under load." },
  { h: "Field experience", p: "Real-world troubleshooting across residential and light commercial equipment." },
  { h: "Engineering mindset", p: "We measure, reason, and verify — instead of swapping parts and hoping." },
  { h: "Accountability", p: "Clean workmanship, clear documentation, and long-term system reliability." },
];

export default function About() {
  return (
    <>
      <Seo title="About | Genuine Forge — HVAC Engineered, Not Guessed" description="Genuine Forge approaches HVAC like engineering, not guesswork — combining field experience, mechanical understanding, and modern diagnostics." />
      <PageHero eyebrow="About" title="HVAC, approached like engineering." lede="Genuine Forge was built around a simple principle: HVAC work should be approached like engineering, not guesswork." image={IMAGES.furnace} />

      <section className="border-t border-white/10 py-20 md:py-28">
        <div className="mx-auto max-w-[1440px] px-6 md:px-12">
          <Reveal className="max-w-3xl">
            <p className="font-display text-2xl font-semibold leading-snug text-white md:text-3xl">
              We combine field experience, mechanical understanding, and modern diagnostics to deliver cleaner repairs and better installations.
            </p>
            <p className="mt-8 font-body text-base leading-relaxed text-slatex-300">
              The brand exists for the property manager, GC, business owner, and serious homeowner who cares about the work being done correctly — the first time, with documentation to prove it. We stay disciplined about scope, honest about diagnosis, and precise in execution.
            </p>
          </Reveal>

          <div className="mt-16 grid gap-px border border-white/10 bg-white/10 md:grid-cols-2 lg:grid-cols-4">
            {VALUES.map((v, i) => (
              <Reveal key={v.h} delay={i * 0.06} className="bg-ink p-8">
                <span className="font-mono text-xs text-brand-cyan">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="mt-4 font-display text-xl font-bold">{v.h}</h3>
                <p className="mt-3 font-body text-sm leading-relaxed text-slatex-300">{v.p}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <EditorialMarquee text="Engineered Reliability · Professional Execution · System Performance · Long-Term Reliability ·" speed={22} />
      <ProcessSection />
      <WhySection />
      <CTASection />
    </>
  );
}
